// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3gX2l","imageUploader":"EGiftCard_imageUploader__3S96x"};